import React, { useEffect, useRef, useState } from 'react'
import './DividendExpectations.scss'
import { Col, Container, Image, Row, Form } from 'react-bootstrap'
import LiveTickerBar from '../../../components/live-ticker-bar/liveTickerBar'
import { useSelector } from "react-redux";
import lodash from 'lodash';
import { findIndex, set } from 'lodash';
import { DividendApi } from "../../../services/dividend/api";
import { Configuration } from "../../../services/dividend/configuration";
import { IndexServiceApi, PageName } from "../../../services/actionHub/api";
import { Configuration as ActionHubConfiguration } from "../../../services/actionHub/configuration"
import { Toast } from 'primereact/toast';
import DropdownPicker from '../../../components/pickers/dropdownPicker';
import Spinner from '../../../components/spinner';
import DataTableComponent from '../../../components/dataTables/dataTable';
import DividendGraphs from '../../../components/charts/dividendCharts/dividendGraphs';
import { APIControl } from '../../../helpers/APIControl';
import { useTranslation } from "react-i18next";
export default function DividendExpectations() {
    const { t } = useTranslation();
    const token = useSelector((state) => state.auth?.token);
    const [visible, setVisible] = useState(false);
    const api = new DividendApi(new Configuration({ basePath: process.env.REACT_APP_DIVIDEND_API_BASE_PATH }), undefined, APIControl(process.env.REACT_APP_DIVIDEND_API_BASE_PATH));
    const actionHubIndexApi = new IndexServiceApi(new ActionHubConfiguration({ basePath: process.env.REACT_APP_ACTION_HUB_API_BASE_PATH }), undefined, APIControl(process.env.REACT_APP_ACTION_HUB_API_BASE_PATH));
    const [indexList, setIndexList] = useState([]);
    const [selectedIndex, setSelectedIndex] = useState();
    const [selectedIndexCode, setSelectedIndexCode] = useState();
    const [tableData, setTableData] = useState([]);
    const toast = useRef(null);
    const [isLoading, setIsLoading] = useState(true);
    const [symbol, setSymbol] = useState();

    const columnsAll = [
        // { id: 0, field: 'fav', displayName: 'Favoriler', header: '', isVisible: true, align: 'left', width: '1%' },
        // { id: 1, field: 'code', displayName: 'Hisse Kodu', header: '', isVisible: true, align: 'left', width: '7%', clikable: true },
        { id: 1, field: 'searchableHeader', displayName: 'Sembol', header: t('tableHeader.symbol'), filterField: "code", isFrozen: true, format: "code-s-f-t", isVisible: true, align: 'left', width: '20%', paddingRight: '10px', sortable: false },

        // { id: 2, field: 'dividendExpectChart', displayName: 'Hisse Kodu', header: '', isVisible: true, align: 'left', width: '7%', clikable: true },
        { id: 3, field: 'expectedDividend', displayName: (new Date().getFullYear() + 1) + ' ' + t('tableHeader.expectedDividend'), header: (new Date().getFullYear() + 1) + ' ' + t('tableHeader.expectedDividend'), isVisible: true, align: 'right', width: '11%', clikable: false, sortable: true },
        { id: 4, field: 'dividendYieldTTM', displayName: (new Date().getFullYear()) + ' ' + t('tableHeader.dividendYield-2'), header: t('tableHeader.dividendYield-2'), isVisible: true, align: 'right', width: '12%', clikable: false, sortable: true },
        { id: 5, field: 'twoYearAverageDividendYield', displayName: t('tableHeader.twoYearAverageDividendYield') + ' (%)', header: t('tableHeader.twoYearAverageDividendYield') + ' (%)', isVisible: true, align: 'right', width: '15% ', clikable: false, sortable: true },
        { id: 6, field: 'threeYearAverageDividendYield', displayName: t('tableHeader.threeYearAverageDividendYield-2') + ' (%)', header: t('tableHeader.threeYearAverageDividendYield-2') + ' (%)', isVisible: true, align: 'right', width: '15% ', clikable: false, sortable: true },
        { id: 7, field: 'pddd', displayName: t('tableHeader.pddd'), header: t('tableHeader.pddd'), isVisible: true, align: 'right', width: '4% ', clikable: false, sortable: true },
        { id: 8, field: 'fk', displayName: t('tableHeader.p-e'), header: t('tableHeader.p-e'), isVisible: true, align: 'right', width: '4% ', clikable: false, sortable: true },
        { id: 9, field: 'ybgYield', displayName: t('tableHeader.ybgYield') + ' (%)', header: t('tableHeader.ybgYield') + ' (%)', isVisible: true, align: 'right', width: '11% ', clikable: false, sortable: true },
        { id: 10, field: 'yearlyYield', displayName: t('tableHeader.yearlyYield') + ' (%)', header: t('tableHeader.yearlyYield') + ' (%)', isVisible: true, align: 'right', width: '20% ', clikable: false, sortable: true },
    ]

    useEffect(() => {
        getActionHubContentData();
    }, []);

    useEffect(() => {
        if (selectedIndexCode !== undefined && selectedIndexCode !== null && selectedIndexCode !== "") {
            getData();
        }
    }, [selectedIndexCode]);


    //#region DataTable Dividend Graph Modal
    const openDividendGrapshModal = (item) => {

        try {
            if (item === undefined || item === null) {
                return;
            }
            setVisible(true);
            setSymbol(item);
        } catch (error) {
            console.log('openDividendGrapshModal error: ', error);
        }

    }

    //#endregion DataTable Dividend Graph Modal

    //#region Dropdown Picker

    const onIndexListChange = (e) => {
        console.log('onIndexChange', e);
        let index = findIndex(indexList, { entityId: e.entityId });
        if (index !== -1) {
            setSelectedIndex(indexList[index]);
            setSelectedIndexCode(indexList[index].code);
        }
        else {
            setSelectedIndex(indexList[0]);
            setSelectedIndexCode(indexList[0].code);
        }
    }

    //#endregion Dropdown Picker


    //#region API CALLS 

    const getActionHubContentData = () => {

        actionHubIndexApi.actionhubCustomindexesGet(token, PageName.DividendExpected).then((res) => {
            if (res.data.error !== undefined && res.data.error !== null && res.data.error !== "") {
                toast.current.show({ severity: 'error', summary: 'Hata Content', detail: res.data.error, life: 3000 });
                console.log('contentGet:  response error');
            }
            else {
                const indexListData = lodash.map(res.data.indexes, (res) => ({
                    name: res['name'].trTr,
                    nameEnUs: res['name'].enUs,
                    code: res.code,
                    entityId: res.entityId,
                }))
                setIndexList(indexListData);
                setSelectedIndex(indexListData[0]);
                setSelectedIndexCode(indexListData[0].code);
            }
        }).catch((err) => {
            // console.log("actionHubIndexApi: " + err);
        });
    }

    const getData = () => {
        try {

            setIsLoading(true);
            api.apiDividendExpecteddividendGet(token, selectedIndexCode).then((res) => {

                if (res.data.error && res.data.error !== undefined && res.data.error !== null && res.data.error !== "") {
                    toast.current.show({ severity: 'error', summary: 'Hata', detail: res.data.error, life: 3000 });
                }
                else {
                    console.log('apiDividendExpecteddividendGet : ', res.data);

                    let data = res.data.map((item) => {
                        return {
                            code: item.equity,
                            expectedDividend: !item.expectedDividend ? item.expectedDividend = null : parseFloat(item.expectedDividend),
                            dividendYieldTTM: !item.dividendYieldTTM ? item.dividendYieldTTM = null : parseFloat(item.dividendYieldTTM),
                            twoYearAverageDividendYield: !item.twoYearAverageDividendYield ? item.twoYearAverageDividendYield = null : parseFloat(item.twoYearAverageDividendYield),
                            threeYearAverageDividendYield: parseFloat(item.threeYearAverageDividendYield),
                            pddd: parseFloat(item.pddd),
                            fk: parseFloat(item.fk),
                            ybgYield: parseFloat(item.ybgYield),
                            yearlyYield: parseFloat(item.yearlyYield),
                            entityId: item.entityId
                        }
                    });
                    setTableData(data);
                    setIsLoading(false);
                }
            }).catch((err) => {
                toast.current.show({ severity: 'error', summary: t('error'), detail: t('aserviceRelatedErrorOccurred'), life: 3000 });
                setIsLoading(false);
                setTableData([]);
            });
        } catch (error) {
            console.log('getData error: ', error);
        }
    }

    //#endregion API CALLS


    const handleClose = () => setVisible(false);
    return (
        <div className='' id='DividendExpectations'>
            <Toast ref={toast} position="bottom-right" />

            <Container>
                <Row>
                    <LiveTickerBar />
                </Row>
                <Row className='m-t-15'>
                    <h1 className='roboto-bold-24 color-text'>{t('dividend.dividendExpectations.title')}</h1>
                </Row>
            </Container>

            <Container className='m-t-10'>
                <Row>
                    <Col md='3' className=''>
                        <DropdownPicker listData={indexList} selectedListItem={selectedIndex} onListItemChange={onIndexListChange} icon={true} />
                    </Col>
                </Row>
            </Container>

            <Container className='m-t-10'>
                <Row>
                    <Col md='12'>
                        {isLoading && <Spinner height="600px" />}
                        {!isLoading &&
                            <div className='dividend-expect-table'>
                                <DataTableComponent columnsProp={columnsAll} dataProp={tableData} columnsSelect={false} search={false} absoluteSearch={false} scrollHeight={'100%'} openDividendGrapshModal={openDividendGrapshModal} sortField={"expectedDividend"} sortOrder={-1} />
                            </div>
                        }
                    </Col>
                </Row>
            </Container>
            {/* <DividendExpectationsModal modalVisible={visible} closeModal={handleClose} chartData={chartdata} modalDataChange={modalDataChange} /> */}
            <DividendGraphs modalVisible={visible} closeModal={handleClose} symbol={symbol} />
        </div>
    )
}

